import React from 'react';
import { Card, Statistic, Row, Col, Tag, Empty } from 'antd';
import {
  LineChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from 'recharts';

function EmergenciasTile({ data, loading }) {
  if (loading) return <Card title="Emergencias del mes" loading />;
  if (!data) {
    return (
      <Card title="Emergencias del mes">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  const { mes, serie, breakdown } = data;

  return (
    <Card title="Emergencias del mes">
      <Row gutter={16} align="middle">
        <Col span={12}>
          <Statistic
            value={mes}
            valueStyle={{ fontSize: '2rem', color: '#f5222d' }}
          />
          <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            <Tag color="green">En servicio: {breakdown.en_servicio}</Tag>
            <Tag color="red">Detenido: {breakdown.detenido}</Tag>
            <Tag color="orange">Observación: {breakdown.en_observacion}</Tag>
            {breakdown.otros > 0 && (
              <Tag color="default">Otros: {breakdown.otros}</Tag>
            )}
          </div>
        </Col>
        <Col span={12} style={{ height: 90 }}>
          {serie && serie.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={serie}>
                <Line
                  type="monotone"
                  dataKey="count"
                  stroke="#1890ff"
                  strokeWidth={2}
                  dot={false}
                />
                <XAxis dataKey="mes" hide />
                <Tooltip />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <div style={{ fontSize: 11, color: '#8c8c8c' }}>Sin serie</div>
          )}
        </Col>
      </Row>
    </Card>
  );
}

export default EmergenciasTile;
